module.exports = __webpack_public_path__ + "static/media/table-control.f36e99de.svg";